import request from '@/utils/request'

//点击分类
export function getList(data) {
  return request({
    url:'Goods/query_class',
    method:'post',
    data
  })
}
//商品
export function getShops(data) {
  return request({
    url:'Goods/goods_list',
    method:'post',
    data
  })
}
//品牌
export function getbrand(data) {
  return request({
    url:'Goods/query_brand',
    method:'post',
    data
  })
}
//一级全部分类
export function getoneClass(data) {
  return request({
    url:'Goods/query_one_class',
    method:'post',
    data
  })
}
//详情
export function getDateils(data) {
  return request({
    url:'Goods/goodsdateils',
    method:'post',
    data
  })
}
//详情
export function getComment_Pinglun(data) {
  return request({
    url:'Goods/ning_comments',
    method:'post',
    data
  })
}
//加入购物车
export function getshopping(data) {
  return request({
    url:'Shopping/add_shopping',
    method:'post',
    data
  })
}

//购物车
export function getqueryshopping(data) {
  return request({
    url:'Shopping/query_shopping',
    method:'post',
    data
  })
}
//删除购物车
export function getdeleteshopping(data) {
  return request({
    url:'Shopping/delete_shopping',
    method:'post',
    data
  })
}
//购物车加数量
export function getadd_num(data) {
  return request({
    url:'Shopping/add_num_shopping',
    method:'post',
    data
  })
}
//购物车减数量
export function getdec_num(data) {
  return request({
    url:'Shopping/dec_num_shopping',
    method:'post',
    data
  })
}
//地址列表
export function getListCity(data) {
  return request({
    url:'Order/query_user_city',
    method:'post',
    data
  })
}

//获取地址详情
export function getFinList(data) {
  return request({
    url:'Order/find_user_city',
    method:'post',
    data
  })
}
//提交订单
export function getaddorder(data) {
  return request({
    url:'Order/add_order',
    method:'post',
    data
  })
}
//收藏商品
export function getaddcollection(data) {
  return request({
    url:'Foc/add_collection',
    method:'post',
    data
  })
}

//收藏商品
export function getquxiaocollection(data) {
  return request({
    url:'Foc/quxiao_collection',
    method:'post',
    data
  })
}
//Goods/gral_goodsdateils   积分商品详情,   id 传商品id 就是goods_id,  gral_id  传 积分商品id,
export function getgoodsdateils(data) {
  return request({
    url:'Goods/gral_goodsdateils',
    method:'post',
    data
  })
}
















// WEBPACK FOOTER //
// ./src/api/List.js